import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" id=\"icon-pause\">\n<g fill=\"#ffffff\">\n\t<g>\n\t\t<path d=\"M9.928,60.75h17.729V3.25H9.928V60.75z\" />\n\t</g>\n\t<g>\n\t\t<path d=\"M36.343,3.25v57.5h17.729V3.25H36.343z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol